'use client';

import { Box, freddyTheme, Link } from '@coolblue-development/freddy';
import selectCategoryInBreadcrumbsTrigger from '@coolblue-development/ga4-events/triggers/Breadcrumbs/selectCategoryInBreadcrumbsTrigger';
import { ArrowLeft } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import { useRouter } from 'next/navigation';
import React from 'react';

import type { BackButtonDesktopProps } from '../../Breadcrumbs.types';
import { isReferrerCoolblue } from '../../Breadcrumbs.utils';
import { StyledBackButtonContainer } from '../BackButton.styled';

export const BackButtonDesktop = ({ hideUntil, referrer }: BackButtonDesktopProps) => {
  const { trackEvent } = useAnalytics();
  const { t } = useTranslation('webshop');
  const router = useRouter();

  if (!referrer || !isReferrerCoolblue(referrer)) {
    return null;
  }

  const trackingParams: Parameters<typeof selectCategoryInBreadcrumbsTrigger>[0] = {
    index: 1,
    total_indices: 1,
    url: referrer,
    redirect: 'back',
    sub_feature: 'horizontal_breadcrumbs'
  };

  const onBackButtonClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    router.back();
    trackEvent(selectCategoryInBreadcrumbsTrigger(trackingParams));
  };

  return (
    <StyledBackButtonContainer hideUntil={hideUntil}>
      <Link
        href={referrer}
        startIcon={<ArrowLeft fill={freddyTheme.color.icon.base} />}
        onClick={event => onBackButtonClick(event)}
      >
        <Box component='span' hideUntil='md'>
          {t('productPage.breadcrumbs.back')}
        </Box>
      </Link>
    </StyledBackButtonContainer>
  );
};
